export default {
    UNKNOWN: 0,
    DASH: 1,
    HLS: 2,
    HDS: 3,
    FLASHLS: 4
};



// WEBPACK FOOTER //
// ./src/js/constants/video-type.js